<template>
  <div>
    <!-- page wrapper start -->
    <div class="pg-wrapper order-status">
      <!-- header -->
      <app-header>
        <div class="pg-title-block" slot="header-foot">
          <div class="is-flex align-items-center">
            <button
              @click="goBack()"
              class="button is-flex nav-back is-rotated-180 mr20 align-items-center"
            >
              <img src="@/assets/img/icon-nav-arrow-right.svg" alt="Go Back" />
            </button>
            <div class="title-block is-flex flex-1 justify-content-between align-items-center">
              <h1 class="title mb0">Order #{{vg_order.id}}</h1>
            </div>
          </div>
        </div>
      </app-header>

      <!-- main -->
      <main class="content-wrapper has-background-white-bis pb0">
        <div class="columns is-marginless">
          <div class="column is-6-widescreen is-6-desktop is-6-tablet is-12-mobile order-status-left">
            <div class="columns is-flex is-centered">
              <div class="column is-7-desktop below-1368 is-10-tablet is-10-mobile">
                <div class="order-timestamp has-text-centered mb15 is-size-15">
                  <span class="time">{{orderTime(vg_order)}}</span>,
                  <span class="date">{{orderDate(vg_order)}}</span>
                </div>
                <div class="order-location has-background-white mb20">
                  <div class="store-item mb0 is-shadowless">
                    <div class="store-logo" v-if="vg_order.location">
                      <img v-if="vg_order.location.images && getStorefeaturedImage(vg_order.location.images)" :src="getStorefeaturedImage(vg_order.location.images)" alt class="order-history-img store-img is-block mr20" />
                      <img v-else src="@/assets/img/icon-marker-green.svg" alt class="is-block mr20" />
                    </div>
                    <div class="store-detail">
                      <div
                        class="store-name has-text-weight-semibold is-uppercase is-flex justify-content-between align-items-center"
                      >
                        <p class="text-dark">{{vg_order.location.display_name}}</p>
                        <div
                          class="distance"
                          v-if="vg_order.location.distance"
                        >{{(vg_order.location.distance/1000).toFixed(1)+' km'}}</div>
                      </div>
                      <div
                        class="store-address text-dark"
                        v-if="vg_order.location.address"
                      >{{vg_order.location.address.formatted_address}}</div>
                      <div class="store-timings is-flex" v-if="locationDetail.hours_of_operation">
                        <span :class="locationDetail.currently_open ? 'status has-text-green' : 'status has-text-red'">{{ locationDetail.currently_open == true ? 'Open' : 'Closed Now' }} &nbsp;</span> • &nbsp;
                        <span class="time order-location-open-status" v-if="locationDetail.hours_of_operation">{{getOpenCloseTime(locationDetail.hours_of_operation)}}</span>
                      </div>
                    </div>
                  </div>
                  <a v-if="vg_order.order_receive_method == 'pickup'" href="#" @click.prevent="getDirection(vg_order.location)" class="button bg-secondary text-white hover-opacity-7 is-full-width has-text-bold">Get Directions</a>
                </div>

                <!-- order items -->
                <div
                  class="product-tile cart-item mb20"
                  v-for="(item, index) in vg_order.order_items"
                  :key="'product'+index"
                >
                  <div class="product-tile__header">
                    <div class="product-tile__thumb-wrapper">
                      <div>
                        <img v-if="item.product_image" :src="item.product_image" alt="Item" />
                      </div>
                    </div>
                    <div class="product-tile__info">
                      <div class="product-tile__brand mb5">
                        <span class="is-uppercase is-size-13 has-text-dark">
                          {{ item.brand_name && (item.brand_name != 'No Brand') ? item.brand_name : '' }}
                        </span>
                        <span>
                          <span class="starting-price font-color">${{ item.price ? item.price.toFixed(2) : '00.00'}}</span>
                        </span>
                      </div>
                      <div class="product-tile__brand mb20">
                        <h3 class="product-tile__name is-size-15 has-text-dark">{{ucFirst(item.product_name)}}  X {{ item.unit}}</h3>
                        <span class="order-record-price min-w-100">
                          <span class="item-weight has-text-dark">{{ item.weight ? item.weight.toFixed(2) : '00.00'}}{{ item.weighting_unit ? item.weighting_unit : '' }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="order-summary-block bg-transparent">
                   <div class="content-box" v-if="vg_order.order_loyalty && (vg_order.order_loyalty.length > 0) && (vg_order.order_loyalty[0].points_earned > 0)">
                     <div class="level is-mobile mb-5">
                      <div class="level-left">
                        <div class="level-item">
                          <p class=" sf-pro-text-regular is-size-13">Points Earned: {{ new Intl.NumberFormat().format(vg_order.order_loyalty[0].points_earned) }}</p>
                        </div>
                      </div>
                    </div>
                   </div>
                  <div class="content-box">
                    <div class="level is-mobile mb-5">
                      <div class="level-left">
                        <div class="level-item">
                          <p class=" sf-pro-text-regular is-size-13">Subtotal</p>
                        </div>
                      </div>
                      <div class="level-right">
                        <div class="level-item">
                          <p
                            class=" sf-pro-text-regular is-size-13"
                          >$ {{ subtotal }}</p>
                        </div>
                      </div>
                    </div>

                    <div class="level is-mobile mb-5" v-if="vg_order.deposit">
                      <div class="level-left">
                        <div class="level-item">
                          <p class=" sf-pro-text-regular is-size-13">Deposit</p>
                        </div>
                      </div>
                      <div class="level-right">
                        <div class="level-item">
                          <p
                            class=" sf-pro-text-regular is-size-13"
                          >$ {{ vg_order.deposit ? vg_order.deposit.toFixed(2) : '0.00' }}</p>
                        </div>
                      </div>
                    </div>

                    <div class="level is-mobile mb-5" v-if="promoCodeDiscount">
                      <div class="level-left">
                        <div class="level-item">
                          <p class=" sf-pro-text-regular is-size-13">Promo Code: {{ vg_order.order_promocodes[0].code }}</p>
                        </div>
                      </div>
                      <div class="level-right">
                        <div class="level-item">
                          <p
                            class=" sf-pro-text-regular is-size-13"
                          >- $ {{ promoCodeDiscount }}</p>
                        </div>
                      </div>
                    </div>
   
                    <div class="level is-mobile mb-5" v-if="loyaltyDiscount">
                      <div class="level-left">
                        <div class="level-item">
                          <p class=" sf-pro-text-regular is-size-13">Points Used: {{ new Intl.NumberFormat().format(vg_order.order_loyalty[0].points_redeemed) }}</p>
                        </div>
                      </div>
                      <div class="level-right">
                        <div class="level-item">
                          <p
                            class=" sf-pro-text-regular is-size-13"
                          >- $ {{ loyaltyDiscount }}</p>
                        </div>
                      </div>
                    </div>

                    <div class="level is-mobile mb-5">
                      <div class="level-left">
                        <div class="level-item">
                          <p class=" sf-pro-text-regular is-size-13">Tax</p>
                        </div>
                      </div>
                      <div class="level-right">
                        <div class="level-item">
                          <p
                            class=" sf-pro-text-regular is-size-13"
                          >$ {{ vg_order.tax ? vg_order.tax.toFixed(2) : '0.00' }}</p>
                        </div>
                      </div>
                    </div>

                     <div class="level is-mobile mb-5" v-if="vg_order.order_receive_method == 'delivery'">
                      <div class="level-left">
                        <div class="level-item">
                          <p class=" sf-pro-text-regular is-size-13">Delivery fee</p>
                        </div>
                      </div>
                      <div class="level-right">
                        <div class="level-item">
                          <p
                            class=" sf-pro-text-regular is-size-13"
                          >$ {{ vg_order.delivery_fee ? vg_order.delivery_fee.toFixed(2) : '0.00' }}</p>
                        </div>
                      </div>
                    </div>

                    <div class="level is-mobile mb-10" v-if="vg_order.order_receive_method == 'delivery'">
                      <div class="level-left">
                        <div class="level-item">
                          <p class=" sf-pro-text-regular is-size-13">Tip</p>
                        </div>
                      </div>
                      <div class="level-right">
                        <div class="level-item">
                          <p
                            class=" sf-pro-text-regular is-size-13"
                          >$ {{ vg_order.tip ? vg_order.tip.toFixed(2) : '0.00' }}</p>
                        </div>
                      </div>
                    </div>

                  </div>
                  <div class="content-box tax-price is-borderless">
                    <div class="level is-mobile" v-if="vg_order.total">
                      <div class="level-left">
                        <div class="level-item">
                          <p class=" sf-pro-text-medium is-size-15">Total</p>
                        </div>
                      </div>
                      <div class="level-right">
                        <div class="level-item">
                          <p
                            class=" sf-pro-text-medium is-size-15"
                          >$ {{vg_order.total.toFixed(2)}}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div class="column is-6-widescreen is-6-desktop is-6-tablet is-12-mobile order-status-right">
            <div class="columns is-flex is-centered">
              <div class="column is-6-desktop is-9-tablet is-9-mobile is-flex is-flex-column">
                <div class="order-pickup-block">
                  <p class="pickup-text  is-size-15 has-text-centered mb20">
                    {{ orderRecieiveTime(vg_order) }}<br/>
                    <span v-if="vg_order.order_receive_method == 'pickup'">Pickup between</span>
                    <span v-else>Delivery between</span>
                    </p>
                  <div class="pickup-duration is-flex justify-content-around align-items-start" v-html="pickupBetween"></div>
                </div>
                <div class="timeline">
                  <!-- For different states of order, add following class to timeline-item element 
                  1) is-completed if order is completed up
                  2) is-processing if order is in process 
                  3) is-active if order is picked up-->
          
                  <div  :class="vg_order.status == 'out_for_delivery' || vg_order.status == 'ready' || vg_order.status == 'completed' ?  'timeline-item is-active' : 'timeline-item'">
                    <div class="timeline-marker"></div>
                    <div class="timeline-content prepared-text">
                      <p class="heading is-size-15" v-if="vg_order.order_receive_method == 'pickup'">Order is ready for pickup</p>
                      <p class="heading is-size-15" v-else>Your order is on its way</p>
                      <p class="">Don’t forget to bring your ID and payment!</p>
                    </div>
                  </div>

                  <div :class="vg_order.status == 'preparing' || vg_order.status == 'out_for_delivery' || vg_order.status == 'ready' || vg_order.status == 'completed' ?  'timeline-item preparing is-completed' : 'timeline-item'">
                    <div class="timeline-marker"></div>
                    <div class="timeline-content">
                      <p class="heading">Order Preparing</p>
                    </div>
                  </div>

                  <div :class="'timeline-item is-completed order-pending'">
                    <div class="timeline-marker is-icon"></div>
                    <div class="timeline-content">
                      <p class="heading">Order Confirmed / Pending</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </main>
      <app-footer></app-footer>
    </div>
  </div>
</template>

<script>
import { format } from "date-fns";
import { upperFirst } from "lodash";
import { mapGetters, mapActions } from "vuex";
import moment from 'moment';
import 'moment-timezone';
import LocationApis from '@/Components/Controllers/LocationApis';
import OrderHistoryApis from '@/Components/Controllers/OrderHistoryApis';
import Helpers from '@/Components/Helpers/Helpers';

export default {
  name: "UserOrderStatus",
  data() {
    return {
      review: true,
      status: "",
      locationDetail: {},
    };
  },

  computed: {
    ...mapGetters({
      // getLoggedInUser: "getLoggedInUser",
      vg_order: "orderhistory/currentOrder"
    }),

    promoCodeDiscount() {
      if( this.vg_order.order_promocodes && (this.vg_order.order_promocodes.length > 0) ){
       return this.vg_order.order_promocodes[0].code ? this.vg_order.order_promocodes[0].applied_value.toFixed(2) : 0;
      }
      return 0;
    },

    loyaltyDiscount() {
      if( this.vg_order.order_loyalty && (this.vg_order.order_loyalty.length > 0 ) && (this.vg_order.order_loyalty[0].reward_amount > 0) ){
       return this.vg_order.order_loyalty[0].reward_amount.toFixed(2);
      }
      return 0;
    },

    subtotal () {
      // if(this.promoCodeDiscount){ // handled on backend
      //   return ( parseFloat(this.vg_order.sub_total) + parseFloat(this.promoCodeDiscount)).toFixed(2);
      // }
      return this.vg_order.sub_total ? this.vg_order.sub_total.toFixed(2) : '0.00';
    },

    pickupBetween() {
      if(this.vg_order.receive_time == ''){
        return '';
      }
      let orderTime = moment.utc(this.vg_order.receive_time).tz( (this.vg_order.location.address && this.vg_order.location.address.timezone_id) ? this.vg_order.location.address.timezone_id : 'America/Toronto');
      let addedValue = moment(this.vg_order.receive_time).add(1, 'hours')
      let orderTimePlusOneHr = moment.utc(addedValue).tz((this.vg_order.location.address && this.vg_order.location.address.timezone_id) ? this.vg_order.location.address.timezone_id : 'America/Toronto');
      return `<div class="pickup-time">
          <div class="hour">${ orderTime.format('h:mm') }</div>
          <div class="am-pm">${ orderTime.format('a') }</div>
        </div>
        <div class="dash">-</div>
        <div class="pickup-time">
          <div class="hour">${orderTimePlusOneHr.format('h:mm')}</div>
          <div class="am-pm">${orderTimePlusOneHr.format('a')}</div>
        </div>`;
    },
  },
  async mounted() {

    if(_.isEmpty(this.vg_order)){
      this.va_snackbar({
        type: 'warning', 
        message: 'Please select order.',
      });
      this.goBack();
    }

    // hit api and sync on mount
    let res = await OrderHistoryApis.fetchOrderById(this.vg_order.id); // status might be change so lets set
    if(res.status == 200) {
      this.va_setCurrentOrder(res.data.payload)
    }

     // If location id is there check if location is open or closed
    if(this.vg_order.location_id && this.vg_order.location && this.vg_order.location.slug) {
    // let res = await LocationApis.fetchBySlug(this.vg_order.location.slug);
     let res = await LocationApis.fetchBySlug(this.vg_order.location.slug);
     if(res.status == 200) {
       this.locationDetail = res.data.payload;
     }
    }
  },
 
  methods: {
     /**
     * Get store featured image
     */
    getStorefeaturedImage(images) {
      return Helpers.getStoreFeaturedImage(images);
    },

    // get order time and date
    orderTime(order) {
      if (_.isEmpty(order)) return;
      let receivedAt = moment(order.created_at).tz( (order.location.address && order.location.address.timezone_id) ? order.location.address.timezone_id : 'America/Toronto');
      return receivedAt.format('h:mm a');
    },

    // get order date
    orderDate(order) {
      if (_.isEmpty(order)) return;
      let receivedAt = moment(order.created_at).tz(order.location.address && order.location.address.timezone_id ? order.location.address.timezone_id : 'America/Toronto');
      return receivedAt.format('MMM DD YYYY');
    },

    // get order date
    orderRecieiveTime(order) {
      if (_.isEmpty(order)) return;
      let receive_time = moment(order.receive_time).tz( (order.location.address && order.location.address.timezone_id) ? order.location.address.timezone_id : 'America/Toronto');
      return receive_time.format('MMM DD, YYYY');
    },

    // text to set first letter capital
    ucFirst(text) {
      if (!text) return;
      return _.upperFirst(text);
    },

    // get opening and closing time for all the days of week
    getOpenCloseTime(location_hours) {

      if(location_hours == undefined){
        return '-';
      }
      let date = new Date();
      let today_date = format(date, "MMMM dd, yyyy ");
      let todaydayname = format(date, "EEEE");
      let item = _.find(location_hours, { day_name: todaydayname });

      // today's date + given opening time
      let today_open_time = new Date(today_date + item.open_time);
      // today's date + given opening time
      let today_close_time = new Date(today_date + item.close_time);

      // return formatted opening and closing date
      return (
        format(today_open_time, "h:mm aaaa") +
        " - " +
        format(today_close_time, "h:mm aaaa")
      );
    },

    goBack() {
      window.history.length > 1 ? this.$router.go(-1) : this.$router.push({ name: 'HomePage' });
    },

    /**
     * Show order receipt details
     */
    // orderReceipt(id) {
    //   bus.$emit("show-modal-order-recepit", {
    //     id: id,
    //     modal: true
    //   });
    // },

    /**
     * Get store direction
     */
    getDirection(storeDetail) {
      // Open external google map
      if(!_.isEmpty(storeDetail) && !storeDetail.address) {
        return '';
      } else {
        window.open(`https://www.google.com/maps/place/${storeDetail.address.formatted_address}/@${storeDetail.address.latitude},${storeDetail.address.longitude},17.55z'`, '_blank');
      }
    },

    ...mapActions({ 
      va_snackbar: "snackbar/setSnackbar",
      va_setCurrentOrder: "orderhistory/setCurrentOrder",
      // va_setSelectedStore: "storelocation/setSelectedStore",
    })
  }
};
</script>

<style scoped>
.store-item .store-logo img {
    display: block;
    max-width: 100px;
}
.timeline .timeline-item::before{
      top: 28%;
}
.timeline .timeline-item.ready::before {
    top: 15%;
    height: 85px;
}
@media screen and (max-width: 1368px) and (min-width: 992px) {
  .below-1368 {
    width: 80% !important;
  }
}
</style>